module.exports = __webpack_public_path__ + "static/media/icon.59c7622e.png";